import type { PublicApiKey } from '@/apilib';
import type { createCopyPasteApi } from './copyPasteWrapper';

export const CopyPasteApiKey: PublicApiKey<typeof createCopyPasteApi> = {
  name: 'CopyPasteApi',
  public: true,
};
